import type { IFetchHookOptions } from 'ts/common/hooks';
import useClientApiFetch from './useClientApiFetch';
import useEvent from './useEvent';

const useClientEventApiFetch = <TResponse>(path: string, fetchOptions?: IFetchHookOptions) => {
    const { brandId, id: eventId } = useEvent();
    return useClientApiFetch<TResponse>(`brand/${brandId}/event/${eventId}/${path}`, fetchOptions);
};

export default useClientEventApiFetch;
